import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { MeetingTemplatesTable } from '../../../features/meeting-templates/components/meeting-templates-table';
import { listMeetingTemplatesOptions } from '../../../features/meeting-templates/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/meeting-templates/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listMeetingTemplatesOptions()),
  component: MeetingTemplatesIndexPage,
});

function MeetingTemplatesIndexPage() {
  const { data: templates } = useSuspenseQuery(listMeetingTemplatesOptions());

  return (
    <div>
      <PageHeader
        title="Быстрый старт"
        description="Шаблоны быстрого старта в mini-app — блок «Быстрый старт» на табе «Встречи»."
        actions={
          <Button asChild>
            <Link to="/meeting-templates/new">Новый шаблон</Link>
          </Button>
        }
      />
      <MeetingTemplatesTable templates={templates} />
    </div>
  );
}
